import * as ActionTypes from '../actions/userAction';

const { USER_LOGIN, USER_LOGOUT, USER_INFO_UPDATE } = ActionTypes
const initialState = {
    authToken: null,
    userInfo: {
        firstName: '',
        lastName: '',
        email: '',
        contactNo: '',
        billAddr: '',
        schoolName: '',
        graduateAt: '',
        targetTest: '',
        targetTestDate: ''
    }
};

const UserStore = (state = initialState, action) => {
    switch (action.type) {
        case USER_LOGIN: {
            return {
                ...state,
                userInfo: action.data
            };
        }
        case USER_INFO_UPDATE: {
            return {
                ...state,
                userInfo: action.data
            };
        }
        case USER_LOGOUT: {
            return {
                ...initialState,
            };
        }

        default:
            return state;
    }
};

export default UserStore;



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js